import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Contracts } from './pages/Contracts';
import { Proposals } from './pages/Proposals';
import { ProposalDetails } from './pages/ProposalDetails';
import { Marketplace } from './pages/Marketplace';
import { Analytics } from './pages/Analytics';
import { Contact } from './pages/Contact';
import { LandingPage } from './pages/LandingPage';
import { Login } from './pages/auth/Login';
import { SignUp } from './pages/auth/SignUp';
import { ResetPassword } from './pages/auth/ResetPassword';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { Callback } from './pages/auth/Callback';
import { Profile } from './pages/Profile';
import { SecuritySettings } from './pages/profile/SecuritySettings';
import { NotificationSettings } from './pages/profile/NotificationSettings';
import { HelpSupport } from './pages/profile/HelpSupport';
import { AuthGuard } from './components/AuthGuard';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth/login" element={<Login />} />
      <Route path="/auth/signup" element={<SignUp />} />
      <Route path="/auth/reset-password" element={<ResetPassword />} />
      <Route path="/auth/forgot-password" element={<ForgotPassword />} />
      <Route path="/auth/callback" element={<Callback />} />
      
      {/* Protected routes */}
      <Route element={<AuthGuard><Layout /></AuthGuard>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/contracts" element={<Contracts />} />
        <Route path="/proposals" element={<Proposals />} />
        <Route path="/proposals/:id" element={<ProposalDetails />} />
        <Route path="/marketplace/*" element={<Marketplace />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/security" element={<SecuritySettings />} />
        <Route path="/profile/notifications" element={<NotificationSettings />} />
        <Route path="/profile/help" element={<HelpSupport />} />
      </Route>

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}